<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-clipboard-list</v-icon>{{$t('profile.setupdefinition.definitionssub')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <SetupDefinitionSubForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SetupDefinitionSubForm from '../../components/setupdefinitionsub/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'SetupDefinitionSub';

const { mapFields } = createHelpers({
  getterType: 'setupdefinitionsub/getField',
  mutationType: 'setupdefinitionsub/updateField'
});

export default {
  name: 'SetupDefinitionSubCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    SetupDefinitionSubForm
  },
  data() {
    return {
      item: {
        'setupDefinition' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('setupdefinitionsub', ['create', 'reset'])
  }
};
</script>
